import {
  REQUEST_INDICATOR_META,
  RECEIVE_INDICATOR_META,
} from 'config/types';
import utils from 'utils';
import selectIndexedIndicators from 'selectors/geography/indexedIndicators';

const { lowerSnakeTransform } = utils.string;

export default function indicatorMetaReducer(state = {}, { type = '', payload } = {}) {
  if (REQUEST_INDICATOR_META === type) {
    return {
      ...state,
      isFetching: state.isFetching.concat(payload.key),
    };
  }
  if (RECEIVE_INDICATOR_META === type &&
    ('usdata' === payload.key || 'international' === payload.key)
  ) {
    /**
     * The values for 'precision' and 'range-breaks' come in as strings and need
     * to be converted to integers, so we will do that here.
     */
    const filteredPayload = payload.data.map((indicator) => ({
      ...indicator,
      precision: parseInt(indicator.precision, 10),
      'range-breaks': parseInt(indicator['range-breaks'], 10),
    }));

    const newPayload = {
      updatedFromWP: true,
      byId: {},
      bySlug: {},
      all: [],
    };
    filteredPayload.forEach((item) => {
      newPayload.byId[item.index] = {};
      newPayload.bySlug[item.slug] = {};
      Object.keys(item).forEach((key) => {
        newPayload.byId[item.index][lowerSnakeTransform(key, '-')] = item[key];
        newPayload.bySlug[item.slug][lowerSnakeTransform(key, '-')] = item[key];
      });
      newPayload.all.push(item.index);
    });

    return {
      ...state,
      geography: selectIndexedIndicators(state, newPayload),
      allIndicators: {
        ...state.allIndicators,
        [payload.key]: newPayload,
      },
      indicator: state.indicator.index ? {
        ...state.indicator,
        ...newPayload.byId[state.indicator.index],
      } : {
        ...state.indicator,
      },
      isFetching: state.isFetching.filter((x) => payload.key !== x),
    };
  }
  return state;
}



// WEBPACK FOOTER //
// ./app/reducers/indicatorMeta.js